
export function htmlDecodeFilter(value:string){
	let parser = new DOMParser;
	let dom = parser.parseFromString(
		'<!doctype html><body>' + value,
		'text/html');
	let decodedString = dom.body.textContent;

	return decodedString??"";
}
